export default __webpack_public_path__ + "static/media/027-Native American.9b7084fa.svg";